import { useEffect } from "react";
import { useSelector } from "react-redux";
import { AppState } from "./../store/app-state";
import { useTranslation } from "react-i18next";

export default function useChat() {
  const user = useSelector((state: AppState) => state.authState.user);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (
      user?.name &&
      user?.email &&
      user?.id &&
      window.location.pathname.indexOf("onboarding") !== 0 &&
      user?.setup
    ) {
      window.Intercom("boot", {
        app_id: "vdjpg93n",
        name: user.name,
        email: user.email,
        user_id: user.id,
        language_override: i18n.language
      });
    }
  }, [user, i18n.language]);
}
